<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="bitlocker-total-wrapper stats-component">
  <div class="bitlocker-title">
    <span class="draggable">{{'bitlocker-compliance.title' | translate}}</span>
  </div>
  <!-- The draggable class above was moved outside of the async below so gridstack
        will see it, otherwise the entire component is draggable -->
  <div *ngrxLet="bitloackerResult$ as bitLockerResult" class="bitlocker-data-wrapper">
      <h2 *ngIf="chooseCustomer; else haveCustomerData" class="title">{{'dashboard.select-a-customer' | translate}}</h2>
      <ng-template #haveCustomerData>
          <div class="bitlocker-chart-wrapper">
              <div #containerRef class="chart-area" [ngStyle]="{'height': graphStyle}">
                  <div *ngIf="hasData(bitLockerResult); else noData" class="chart">
                      <ngx-charts-pie-chart
                              [view]="[containerRef.offsetWidth, containerRef.offsetHeight]"
                              [results]="bitLockerResult?.chartData"
                              [legend]="showLegend"
                              [labels]="showLabels"
                              [doughnut]="isDoughnut"
                              [legendPosition]="legendPosition"
                              legendTitle=""
                              arcWidth=".34"
                              (select)="onClick($event)"
                              [scheme]="colorScheme">
                      </ngx-charts-pie-chart>
                  </div>
                  <ng-template #noData>
                      <div *ngIf="bitLockerResult" class="no-chart-data">
                          <span>{{'bitlocker-compliance.no-data' | translate}}</span>
                      </div>
                  </ng-template>
              </div>
              <div class="bitlocker-relative-changes-wrapper">
                  <div class="bitlocker-relative-changes-text">
                      <div>
                          <div class="sub-title">{{'bitlocker-compliance.subtitle' | translate}}</div>
                          <div>
                              <div class="data">{{'TOTAL' | translate}} - {{bitLockerResult?.response.total}}</div>
                              <div class="data">{{'COMPLIANT' | translate}} - {{bitLockerResult?.response.compliant}}</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </ng-template>
  </div>
</div>